<template>
    <div class="form-group">
        <label for="clients-control" v-if="label">Cliente <span class="field-required-mark" v-if="!!required">*</span></label>
        <select class="form-control" name="clients-control" @change="onChange" id="clients-control" v-bind="$attrs" v-on="selectListeners">
            <option value="" v-if="placeholder">Cliente</option>
            <option value="" v-else>-- Seleccione --</option>
            <option v-for="client in clients" :key="client.id" :value="client.id">{{ client.name }}</option>
        </select>
        <span class="field-error" v-if="!!hasError">{{ errorMessage }}</span>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    inheritAttrs: false,
    props: {
        placeholder: {
            type: Boolean,
            default: false
        },
        label: {
            type: Boolean,
            default: true
        },
        errorMessage: {
            type: String,
            default: 'Debe seleccionar el cliente'
        },
        hasError: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        isObject: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['clients']),
        selectListeners() {
            const { input, ...rest } = this.$listeners
            return rest
        }
    },
    methods: {
        onChange(event){
            const { target } = event;
            const value = parseInt(target.value);

            let client = value;
            if(this.isObject){
                client = this.clients.find(item => item.id === value)
            }
            
            this.$emit('input', client);
        }
    },
    created() {
        this.load('clients');
    }
}
</script>